import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_12 = { class: "mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_14 = { class: "mt-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_16 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_18 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_19 = { class: "indicator-label" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_21 = { class: "card mb-5 mb-xl-10" }
const _hoisted_22 = { class: "card-header" }
const _hoisted_23 = { class: "card-title m-0" }
const _hoisted_24 = { class: "m-0" }
const _hoisted_25 = { class: "card-body p-9" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group d-flex flex-wrap" }
const _hoisted_29 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-group d-flex flex-wrap" }
const _hoisted_32 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group d-flex flex-wrap" }
const _hoisted_36 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "form-group d-flex flex-wrap" }
const _hoisted_39 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-group d-flex flex-wrap" }
const _hoisted_43 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group d-flex flex-wrap" }
const _hoisted_46 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "form-group d-flex flex-wrap" }
const _hoisted_50 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "form-group d-flex flex-wrap" }
const _hoisted_53 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "form-group d-flex flex-wrap" }
const _hoisted_57 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "form-group d-flex flex-wrap" }
const _hoisted_60 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "form-group d-flex flex-wrap" }
const _hoisted_64 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "form-group d-flex flex-wrap" }
const _hoisted_67 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "form-group d-flex flex-wrap" }
const _hoisted_71 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_72 = { class: "mt-3" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "form-group d-flex flex-wrap" }
const _hoisted_77 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_78 = { class: "col-md-6" }
const _hoisted_79 = { class: "form-group d-flex flex-wrap" }
const _hoisted_80 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "form-group d-flex flex-wrap" }
const _hoisted_84 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = { class: "form-group d-flex flex-wrap" }
const _hoisted_87 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_88 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_89 = { class: "mb-0" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "svg-icon svg-icon-3" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "svg-icon svg-icon-3" }
const _hoisted_96 = { class: "row mb-7" }
const _hoisted_97 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_98 = { class: "dataTables_length" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("option", { value: "30" }, "30", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("option", { value: "200" }, "200", -1)
const _hoisted_104 = [
  _hoisted_99,
  _hoisted_100,
  _hoisted_101,
  _hoisted_102,
  _hoisted_103
]
const _hoisted_105 = { class: "number" }
const _hoisted_106 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_107 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_109 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_110 = { class: "indicator-label" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MBTaggings = _resolveComponent("MBTaggings")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_AddInventoryRuleModal = _resolveComponent("AddInventoryRuleModal")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("merchants.basicSegmentation")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_MBTaggings, {
              ref: "basicSegmentation",
              "tagging-items": _ctx.basic_segmentationSource,
              "tagging-values": _ctx.basic_segmentationValues
            }, null, 8, ["tagging-items", "tagging-values"]),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("merchants.brandCoverage")), 1),
            _hoisted_7,
            _createVNode(_component_MBTaggings, {
              ref: "brandCoverage",
              "tagging-items": _ctx.brand_coverageSource,
              "tagging-values": _ctx.brand_coverageValues
            }, null, 8, ["tagging-items", "tagging-values"]),
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t("merchants.productDynamic")), 1),
            _hoisted_9,
            _createVNode(_component_MBTaggings, {
              ref: "productDynamic",
              "tagging-items": _ctx.product_dynamicSource,
              "tagging-values": _ctx.product_dynamicValues
            }, null, 8, ["tagging-items", "tagging-values"]),
            _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("merchants.inventoryCapability")), 1),
            _hoisted_11,
            _createVNode(_component_MBTaggings, {
              ref: "inventoryCapabilaity",
              "tagging-items": _ctx.inventory_capabilitySource,
              "tagging-values": _ctx.inventory_capabilityValues
            }, null, 8, ["tagging-items", "tagging-values"]),
            _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("merchants.priceSystem")), 1),
            _hoisted_13,
            _createVNode(_component_MBTaggings, {
              ref: "priceSystem",
              "tagging-items": _ctx.price_SystemSource,
              "tagging-values": _ctx.price_SystemValues
            }, null, 8, ["tagging-items", "tagging-values"]),
            _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t("merchants.onlinePIMData")), 1),
            _hoisted_15,
            _createVNode(_component_MBTaggings, {
              ref: "onlinePimData",
              "tagging-config": _ctx.online_pim_DataConfig,
              "tagging-items": _ctx.online_pim_DataSource,
              "tagging-values": _ctx.online_pim_DataValues
            }, null, 8, ["tagging-config", "tagging-items", "tagging-values"])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_17,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("common.backToList")), 1)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, [
                _hoisted_20,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.saveChanges")), 1)
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t("merchants.pimProfile")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("merchants.serviceStatus")), 1),
                  _createVNode(_component_el_form_item, { prop: "service_status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.service_status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.service_status) = $event)),
                        "active-value": 1,
                        "inactive-value": 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("merchants.selectedBrands")), 1),
                  _createVNode(_component_el_form_item, { prop: "selected_brands" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.selected_brands,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.selected_brands) = $event)),
                        multiple: "",
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        placeholder: _ctx.$t('common.plsEnter'),
                        "remote-method": _ctx.searchBrandItems,
                        loading: _ctx.brandLoading
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("merchants.selectedCategories")), 1),
                  _createVNode(_component_el_form_item, { prop: "selected_categories" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_cascader, {
                        modelValue: _ctx.formData.selected_categories,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.selected_categories) = $event)),
                        "show-all-levels": false,
                        options: _ctx.categories,
                        props: _ctx.propsData,
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "options", "props", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("merchants.selectedTargetGroups")), 1),
                  _createVNode(_component_el_form_item, { prop: "selected_target_groups" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_cascader, {
                        modelValue: _ctx.formData.selected_target_groups,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.selected_target_groups) = $event)),
                        options: _ctx.target_groups,
                        props: _ctx.propsData,
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "options", "props", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("merchants.productIdentifier")), 1),
                  _createVNode(_component_el_form_item, { prop: "product_identifier" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.product_identifier,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.product_identifier) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("merchants.basicData")), 1),
                  _createVNode(_component_el_form_item, { prop: "basic_data" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.basic_data,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.basic_data) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("merchants.categories")), 1),
                  _createVNode(_component_el_form_item, { prop: "categories" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.categories,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.categories) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("merchants.digitalMediaAssets")), 1),
                  _createVNode(_component_el_form_item, { prop: "digital_media_assets" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.digital_media_assets,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.digital_media_assets) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("merchants.contentMarketing")), 1),
                  _createVNode(_component_el_form_item, { prop: "content_marketing" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.content_marketing,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.content_marketing) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t("merchants.pricing")), 1),
                  _createVNode(_component_el_form_item, { prop: "pricing" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.pricing,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.pricing) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("merchants.inventory")), 1),
                  _createVNode(_component_el_form_item, { prop: "inventory" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.inventory,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.inventory) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t("merchants.packaging")), 1),
                  _createVNode(_component_el_form_item, { prop: "packaging" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.packaging,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.packaging) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("merchants.dataQuality")), 1),
                  _createVNode(_component_el_form_item, { prop: "data_quality" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.data_quality,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.data_quality) = $event)),
                        clearable: "",
                        placeholder: _ctx.$t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Full Service",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "Data Extend",
                            value: 20
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inherit",
                            value: 30
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", _hoisted_72, _toDisplayString(_ctx.$t("merchants.stockAggregation")), 1),
            _hoisted_73,
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("merchants.totalIndexedSPU")), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.detail.total_indexed_spu,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.detail.total_indexed_spu) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter'),
                        disabled: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t("merchants.totalInStockSPU")), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.detail.total_in_stock_spu,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.detail.total_in_stock_spu) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter'),
                        disabled: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t("merchants.totalIndexedSKU")), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.detail.total_indexed_sku,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.detail.total_indexed_sku) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter'),
                        disabled: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t("merchants.totalInStockSKU")), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.detail.total_in_stock_sku,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.detail.total_in_stock_sku) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.plsEnter'),
                        disabled: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("h3", _hoisted_89, _toDisplayString(_ctx.$t("merchants.inventoryRules")), 1),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modal_add_rule",
                title: "Add",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleAddRule && _ctx.handleAddRule(...args))),
                disabled: _ctx.options.inventoryRuleLoading
              }, [
                _createElementVNode("span", _hoisted_91, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                ])
              ], 8, _hoisted_90)), [
                [_directive_auth, { auth: ['update'] }]
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createVNode(_component_el_table, {
                data: _ctx.options.inventoryRuleList,
                style: {"width":"100%"},
                size: "small",
                "min-width": "220",
                class: "mb-7"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.salesChannels')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.__show.channel_id != "" && row.__show.channel_id != 0
                    ? row.__show.channel_id
                    : "All"), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.brand')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.__show.brand_id != "" && row.__show.brand_id != 0
                    ? row.__show.brand_id
                    : "All"), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.category')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.__show.category_id != "" && row.__show.category_id != 0
                    ? row.__show.category_id
                    : "All"), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.key'),
                    prop: "key_type",
                    formatter: _ctx.getOptionsLabel
                  }, null, 8, ["label", "formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.value'),
                    prop: "key_value"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('merchants.duration'),
                    prop: "duration",
                    formatter: _ctx.getOptionsLabel
                  }, null, 8, ["label", "formatter"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                    label: "",
                    width: "100",
                    align: "right"
                  }, {
                    default: _withCtx(({ $index, row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_add_rule",
                        title: "Edit",
                        onClick: ($event: any) => (_ctx.handleEditRule($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_93, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_92),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                        title: "Delete",
                        onClick: ($event: any) => (_ctx.handleDeleteRule($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_95, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                        ])
                      ], 8, _hoisted_94)
                    ]),
                    _: 1
                  })), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["data"]),
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("label", null, [
                      _createElementVNode("select", {
                        name: "kt_customers_table_length",
                        class: "form-select form-select-sm form-select-solid",
                        onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.setInventoryRulePerPage && _ctx.setInventoryRulePerPage(...args)))
                      }, _hoisted_104, 32)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_105, " Show " + _toDisplayString(_ctx.rowsInventoryRuleStartNumber) + " to " + _toDisplayString(_ctx.rowsInventoryRuleEndNumber) + " Records，All " + _toDisplayString(_ctx.options.inventoryRuleTotal) + " Records ", 1)
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createVNode(_component_el_pagination, {
                    "current-page": _ctx.options.inventoryRuleCurrentPage,
                    "onUpdate:current-page": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.options.inventoryRuleCurrentPage) = $event)),
                    total: _ctx.options.inventoryRuleTotal,
                    "page-size": _ctx.options.inventoryRulePageSize,
                    onCurrentChange: _ctx.handleInventoryRuleCurrentChange,
                    layout: "prev, pager, next",
                    "hide-on-single-page": true,
                    background: ""
                  }, null, 8, ["current-page", "total", "page-size", "onCurrentChange"])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.options.inventoryRuleLoading]
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_108,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("common.backToList")), 1)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_109, [
              _createElementVNode("span", _hoisted_110, [
                _hoisted_111,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.saveChanges")), 1)
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_AddInventoryRuleModal, {
      id: _ctx.ruleId,
      "merchant-id": _ctx.formData.merchant_id,
      onUpdateList: _ctx.getUpdateInventoryRuleList,
      onResetForm: _ctx.handleAddRule,
      tableData: _ctx.selectData
    }, null, 8, ["id", "merchant-id", "onUpdateList", "onResetForm", "tableData"])
  ], 64))
}